import { ExpressionLogMeta, TemplateConfig } from '@flowx/core-sdk'

/**
 * The half of an `expression` log meta only the caller knows — identity is
 * stamped from the TemplateConfig the evaluation already carries.
 */
export type ExpressionLogInfo = Omit<ExpressionLogMeta, 'templateId' | 'componentIdentifier'>

/**
 * Build the identity meta for `expression` log events from a TemplateConfig.
 * Emission is opt-in: no info in, no meta out, so the evaluation stays silent.
 */
export const expressionLogMeta = (
  templateConfig: TemplateConfig,
  info: ExpressionLogInfo | undefined
): ExpressionLogMeta | undefined =>
  info && {
    ...info,
    templateId: templateConfig?.flowxUuid,
    componentIdentifier:
      templateConfig && 'componentIdentifier' in templateConfig
        ? String(templateConfig.componentIdentifier)
        : undefined,
  }
